import service from "./service";
export function login(username, password) {
  return service.post("/v1/auth/login", {
    username,
    password
  });
}
export function logout() {
  return service.post("/v1/auth/logout", null);
}

export function adminGetAllUser({
  limit = "5",
  page = "1",
  sort = "id",
  sortType = "DESC",
  filter = ""
}) {
  return service.get(
    `/v1/user?limit=${limit}&page=${page}&sort=${sort}&sortType=${sortType}&filter=${filter}`
  );
}

export function getInfo() {
  return service.get("/v1/auth/info");
}

export function updateInfo(data) {
  return service.post("/v1/auth/info", { user: data });
}

export const list = listQuery => {
  return service.get("/v1/user", listQuery);
};

export function create(user) {
  return service.post("/v1/user", { user });
}
export const update = (id, user) => {
  return service.post(`/v1/user/${id}/update`, { user });
};
export const updateRole = (id, roleId) => {
  return service.post(`/v1/user/${id}/role`, { roleId });
};

export const removeList = list => {
  return service.post(`/v1/user/deletes`, { list });
};

export const resetPassword = id => {
  return service.post(`/v1/user/${id}/reset-password`);
};
export const verifyUrlRequest = validate => {
  return service.post(`/v1/user/verify/url-request`, { validate });
};

export const verifyUrl = validate => {
  return service.post(`/v1/user/verify/url-request`, { validate });
};

export const password = (validate, user) => {
  return service.post(`/v1/user/password`, { validate, user });
};
